import React, { createContext, useContext, useState, useEffect } from 'react';
import { settingsApi } from '../services/api';
import api from '../services/api';
import { setCurrency } from '../utils/currencyFormat';

const BrandingContext = createContext({});

const DEFAULTS = {
  app_name: 'ProjectBook Pro\u2122',
  developer_name: 'SGK Apps',
  developer_url: 'https://www.sgkapps.com',
  developer_tagline: 'A product of VRV Technical & Technology Solutions FZ LLC',
  company_name: 'My Company',
  logo_url: '',
};

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULTS);

  const applySettings = (d) => {
    setBranding({
      app_name: d.app_name || DEFAULTS.app_name,
      developer_name: d.developer_name || DEFAULTS.developer_name,
      developer_url: d.developer_url || DEFAULTS.developer_url,
      developer_tagline: d.developer_tagline || DEFAULTS.developer_tagline,
      company_name: d.company_name || DEFAULTS.company_name,
      logo_url: d.logo_url || '',
    });
    if (d.currency) setCurrency(d.currency, d.currency_symbol);
  };

  const loadBranding = async () => {
    try {
      // Try public branding endpoint first (works without auth)
      const res = await api.get('/api/settings/branding');
      applySettings(res.data || {});
    } catch {
      try {
        // Fall back to authenticated settings endpoint
        const res = await settingsApi.get();
        applySettings(res.data || {});
      } catch {
        // Use defaults
      }
    }
  };

  useEffect(() => { loadBranding(); }, []);

  return (
    <BrandingContext.Provider value={{ ...branding, reload: loadBranding }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}
